export const HeaderCloseIconPosition = {
  Left: "left",
  Right: "right"
};
